import axiosPost from "./axiosPost";

export const MIAConnectionIns = async (params, credentials) => {
    const body = {
        service: "MIAConnectionIns",
        params
    };
    return await axiosPost(body, credentials);
};
